// src/redux/sagas/comboSaga.ts
import { call, put, takeEvery, select } from 'redux-saga/effects';
import { request } from '../../api/request';
import ENDPOINTS from '../../api/endpoints';
import {
  fetchComboRequest,
  fetchComboSuccess,
  fetchComboFailure,
  ComboResponse,
} from '../slices/comboSlice';
import { shouldSkipApiCalls } from '../../utils/appConfig';
import staticComboData from '../../data/combo.json';

function* fetchComboDataSaga(): Generator<any, void, any> {
  // Skip API calls if in preview mode
  if (shouldSkipApiCalls()) {
    // Convert static data to match expected combo array type
    const comboData = staticComboData as unknown as ComboResponse['combos'];
    yield put(fetchComboSuccess(comboData));
    return;
  }

  try {
    const url = `${ENDPOINTS.COMBO_API_PATH}?type=website`;
    const response = yield call(request<ComboResponse>, {
      method: 'GET',
      url,
    });
    
    // Extract combos array from the API response structure
    const combosData = response.data?.combos || response.data;
    
    yield put(fetchComboSuccess(combosData));
    
    // Widget updates are handled by useWidgetDataUpdater hook to avoid timing issues
  } catch (error: unknown) {
    const errorMessage =
      error instanceof Error ? error.message : 'Failed to fetch combo data';
    yield put(fetchComboFailure(errorMessage));
  }
}

export function* watchComboSaga() {
  yield takeEvery(fetchComboRequest.type, fetchComboDataSaga);
}
